module.exports = __webpack_public_path__ + "img/fo.ccccf6d2.svg";